export default __webpack_public_path__ + "static/media/image-8.ee25d2e5.gif";